import {
    Container,
    Card
} from "reactstrap";
import styles from './styles.module.scss';
import Link from 'next/link';
// import { formatDistance } from 'date-fns';
import { trimText } from '/functions/trimText';
import { stripTags } from '/functions/stripTags';
import GeoLocation from '/public/site-assets/svg/geo-location.svg';
import Pound from '/public/site-assets/svg/pound.svg';

export default function AllJobsCard({
    title,
    description,
    url_slug,
    addresses,
    published_at,
    salary_package
}) {
    return (
        <Card className={`${styles.root} p-4 rounded-3 border`}>
            {/* <p className="fs-6">
                    <small>
                        <span className="pe-1">Posted</span>
                        <time
                            dangerouslySetInnerHTML={{
                                __html: formatDistance(new Date(published_at), new Date(), {
                                    addSuffix: true
                                })
                            }}
                        /></small></p> */}
            <h5 className="mb-4 job-title">
                <a href={`/jobs/${url_slug}`} className="text-decoration-none">
                    <span dangerouslySetInnerHTML={{ __html: title }}></span>
                </a>
            </h5>
            <div className="d-flex flex-nowrap justify-content-between align-items-start">
                <div className="d-flex flex-wrap">
                    {addresses[0] ? <>
                        <div className="position-relative me-3 mb-3"><span className="icon position-absolute"><GeoLocation /></span><span dangerouslySetInnerHTML={{ __html: addresses[0] }} className={`pt-2 pb-2 ps-5 pe-3 bg-white rounded-3 job-location d-flex`} /></div></> : ""}
                    {salary_package ? <>
                        <div className="position-relative me-3 mb-3"><span className="icon position-absolute"><Pound /></span><span dangerouslySetInnerHTML={{ __html: salary_package }} className={`pt-2 pb-2 ps-5 pe-3 bg-white rounded-3 job-salary-package d-flex`} /></div></> : ""}
                </div>
                <a
                    href={`/jobs/${url_slug}`}
                    className="primaryBtn-outline-white m-0 text-nowrap d-none d-lg-inline-block"
                    dangerouslySetInnerHTML={{ __html: `Apply now` }}
                />
            </div>
            <div
                dangerouslySetInnerHTML={{ __html: description }}
                className="description mt-3 mb-4"
            />
            <div className="d-block d-lg-none text-end">
                <a
                    href={`/jobs/${url_slug}`}
                    className="primaryBtn-outline-white m-0 text-nowrap"
                    dangerouslySetInnerHTML={{ __html: `Apply now` }}
                />
            </div>
        </Card >
    )
}